import {useI18n} from 'i18n/I18nContext'
import {appLocaleToBcp47} from 'i18n/locales'
import React from 'react'
import {
  Invite,
  useEventInvites,
} from 'organization/Event/Attendants/EventInvitesProvider'
import {confirmAlert} from 'react-confirm-alert'
import HighlightOffIcon from '@mui/icons-material/HighlightOff'
export const ListInvite = (props: {invite: Invite; index: number}) => {
  const {invite, index} = props
  const {t, locale} = useI18n()
  const dateLocale = appLocaleToBcp47(locale)

  const {remove} = useEventInvites()

  const removeInvite = () => {
    confirmAlert({
      message: t('orgInvited.confirmDeleteInvite'),
      buttons: [
        {
          label: t('common.yes'),
          onClick: () => {
            remove(invite)
          },
        },
        {
          label: t('common.no'),
          onClick: () => {
            // nothing
          },
        },
      ],
    })
  }

  return (
    <tr key={index}>
      <td> {invite.id} </td>
      <td>{invite.email} </td>
      <td>
        {invite.reservation ? (
          <span className={'status__tag bg-green'}>
            <span>{t('common.yes').toUpperCase()}</span>
          </span>
        ) : (
          <span className={'status__tag bg-warning'}>
            <span>{t('common.no').toUpperCase()}</span>
          </span>
        )}{' '}
      </td>
      <td> {new Date(invite.created_at).toLocaleString(dateLocale)}</td>
      <td>
        <span className={'status__tag bg-green'}>
          <span>{t('orgInvited.statusInvited')}</span>
        </span>
      </td>

      <td>
        <button onClick={removeInvite}>
          <HighlightOffIcon color="warning" fontSize="large" />
        </button>
      </td>
    </tr>
  )
}
